<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    宝体站<br>
站点介绍<br>
车站位于深圳市宝安新中心区的核心主轴上,中心点在罗田路与新湖路的交汇处，延新湖路呈东西向布设车站装修以白色为主，空间简洁明快，绿色的立柱给人以生机勃勃的感觉，简单的材料组合及明亮的灯具，打造出富有现代气息的地下空间。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:29	23:15	1号线	2分钟	4分40秒<br>
机场东	06:05	23:53	1号线	2分钟	4分40秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:35	23:15	1号线	3分45秒	5分45秒<br>
机场东	06:11	23:51	1号线	3分45秒	5分45秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:35	00:15	1号线	3分45秒	5分45秒<br>
机场东	06:11	00:51	1号线	3分45秒	5分45秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
新湖路北侧（东）、尚都、宝安体育中心游泳馆、宝安体育中心<br><br>
B出入口:<br>
新湖路北侧（西）、罗田路、达海花园、花样年•花郡、金成时代家园、君逸世家、裕丰花园<br><br>
C出入口:<br>
新湖路南侧（西）、幸福海岸、西岸花园、第五大道、深业新岸线、宝安区妇幼保健院<br><br>
D出入口:<br>
新湖路南侧（东）、宝安区体育中心体育场（竹林体育场）<br><br>
公交换乘信息<br>
A出入口:<br>
公交站名： 宝安体育馆<br>
M350、M375、M377、M470、M473、假日专线1<br><br>
B出入口:<br>
公交站名： 君逸世家<br>
B826、 M470、M473、 M553、假日专线1、B847、M250、M330、M350、M375、M377<br><br>
D出入口:<br>
公交站名： 宝安体育馆<br>
B828、 M350、M375、M377、M470 、 M473、高峰专线122、假日专线1<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>